import {
  CugatePage,
  AuthPage,
  ImpressumPage,
  PrivacyPolicyPage,
  OurTeamPage,
  ProfilePage,
  SubscribePage,
  MembershipPage,
  CheckoutPage,
  AllTracksPage,
  DashboardPage,
} from "./views";
import AuthRoute from "./utils/AuthRoute";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/JWTAuthContext";
import { DefaultLayout } from "./components";
import Root from "./components/Root";
import { TrackViewPage } from "./views/tracks/view-track";
import { EmailVerifyPage } from "./views/auth/email-verify";
import { EmailRequiredPage } from "./views/auth/email_required";
import EditTrack from "./views/tracks/edit-track";
import NewTrack from "./views/tracks/new-track";
import LabelsPage from "./views/labels";
import MembersPage from "./views/members";
import AnalyseView from "./components/tracks/all-tracks/AnalyseView";
import UploadView from "./components/tracks/all-tracks/UploadView";
import AdminPageUsers from "./views/admin/users";
import ReleasesPage from "./views/releases";
import RecoveryPassword from "./views/auth/recovery_password";
import ResetPassword from "./views/auth/reset-password";
import ReleaseOverview from "./views/release-overview";
// import ReleaseOverviewEdit from "./views/releases/manage-release";
// import TrackOverlay from "./components/track-overlay/track-overlay";
// import ReleaseOverlay from "./components/track-overlay/release-overlay";
// import EditRelease from "./views/releases/edit";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <DefaultLayout>
          <Routes>
            <Route element={<AuthRoute />}>
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile/subscribe" element={<SubscribePage />} />
              <Route path="/membership" element={<MembershipPage />} />
              <Route path="/checkout/:id" element={<CheckoutPage />} />

              <Route path="/dashboard" element={<DashboardPage />} />

              <Route
                path="/all-tracks"
                element={<AllTracksPage mode="normal" />}
              />
              <Route
                path="/track/edit/:id"
                element={<EditTrack mode="edit" />}
              />
              <Route path="/track/new" element={<NewTrack mode="new" />} />
              <Route
                path="/my-tracks"
                element={<AllTracksPage mode="my-track" />}
              />
              <Route
                path="/track/duplicate/:id"
                element={<EditTrack mode="duplicate" />}
              />
              <Route path="/dashboard/track/:id" element={<TrackViewPage />} />

              <Route path="/all-labels" element={<LabelsPage />} />
              <Route path="/all-members" element={<MembersPage />} />

              <Route path="/all-releases" element={<ReleasesPage />} />
              {/* <Route path="/release/new" element={<EditRelease mode="new"/>} />*/}
              <Route path="/release/edit" element={<ReleaseOverview />} />
              <Route path="/release/duplicate" element={<ReleaseOverview />} />
              <Route path="/analyse-upload/:id" element={<AnalyseView />} />
              <Route path="/analyse-uploads" element={<UploadView />} />

              {/* New routes added by Ryosuke */}
              <Route path="/release-overview" element={<ReleaseOverview />} />
              {/* <Route path="/track-overlay" element={<TrackOverlay />} /> */}
              {/* <Route path="/release-overlay" element={<ReleaseOverlay />} /> */}
            </Route>

            <Route path="/" element={<Root />} />
            <Route path="/login" element={<AuthPage page={0} />} />
            <Route path="/email-verify/:token" element={<EmailVerifyPage />} />
            <Route path="/email-required" element={<EmailRequiredPage />} />
            <Route path="/recovery-password" element={<RecoveryPassword />} />
            <Route path="/reset-password/*" element={<ResetPassword />} />
            <Route path="/register" element={<AuthPage page={1} />} />
            <Route path="/cugate" element={<CugatePage />} />
            <Route path="/our-team" element={<OurTeamPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route>
              <Route path="/admin/users" element={<AdminPageUsers />}></Route>
            </Route>
          </Routes>
        </DefaultLayout>
      </AuthProvider>
    </BrowserRouter>
  );
}
